var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"tab"}},[_c('div',{staticClass:"title"},[_c('p',[_vm._v(_vm._s(_vm.titleName))])]),_c('div',{staticClass:"tablList"},[_c('vueSeamless',{staticClass:"seamless-warp",attrs:{"data":_vm.list}},_vm._l((_vm.list),function(item,index){return _c('p',{key:index,on:{"click":_vm.goInfo}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }